import React from "react";

export default function PlusIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 1.84619V14.1539"
        stroke="#323232"
        strokeWidth="3.35664"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1538 8H1.84613"
        stroke="#323232"
        strokeWidth="3.35664"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
